// * * * * * * * * * * * * * * * * * * * * 
//
// On donne le focus à la fenetre du site et non au navigateur
//
// * * * * * * * * * * * * * * * * * * * * 
$(window).focus()

// * * * * * * * * * * * * * * * * * * * *
//
// DOM READY : init function
//
// * * * * * * * * * * * * * * * * * * * *
$(document).ready(function () {
  
  // Fix access via JS
  fn_rgaa_iframe()
  
  // Check MQ
  fn_mq()
	
  fn_modal()
  // fn_scroll_top()
  
  // Show message when browser is < IE11
  fn_update_browser()
  
  fn_cover()
  fn_sticky()
  fn_float_label()
  fn_overflow()
  
  // Sliders
  fn_owl_carousel()
  
  // NAVigation
  fn_navigation_rwd ()
  
  // Slider news md
  fn_slider_md_newslaunch()
  
  // BS modal
  fn_modal_bs()
  
  // Add a <title> to SVG > G > Path element from its Attribute Title so that the a system tooltip is shown before the attribute is emptied by BS4 popover Fn. (Should fix also SVG global title).
  // To be kept before the popover call (coz title is emptied once popover JS is triggered) 
  fn_svg_title()
  
  // BS Pop
  fn_popover()
  
  // List anchors
  fn_list_anchors()
  
  // Masthead video
  fn_masthead()
  
  // Printer
  fn_printer()
  
  // Profile picker
  fn_profile_picker()
  
  // Tab panel BS4
  // new Tabpanel('tab-panels__wrapper')
  fn_bs_tabpanel()
  
  /*   // HC widget demos
  fn_hc_w1()
  fn_hc_w2()
  fn_hc_w3() */
  
  // Faux lazy load
  fn_faux_lazyload_hc_widgets ()
  
  // Hide icon when target-blank link wraps an img
  fn_img_target_blank()
  
  // Set contact button just after the last addthis button
  // setTimeout(fn_share_tools, 2000); //  (/!\ has to be launched via callback of addthis.js)
  
  // Set focus on close button in Search panel
  fn_search()

});
